import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

@Directive()
export abstract class MeetingMinuteRowsBase {

  @Input({ required: true }) rows!: FormArray<FormGroup>;
  @Input() readonlyRows: boolean = false;

  @Output() addRow = new EventEmitter<void>();
  @Output() removeRow = new EventEmitter<number>();

  protected abstract readonly idControlName: string;
  protected abstract readonly rowLabel: string;

  constructor(protected confirmationDialogService: ConfirmationDialogService) { }

  get controls(): FormGroup[] {
    return this.rows?.controls ?? [];
  }

  getControl(row: FormGroup, name: string): FormControl {
    return row.get(name) as FormControl;
  }

  rowId(row: FormGroup): number | null {
    const value = row.get(this.idControlName)?.value;
    return value == null || value === '' ? null : Number(value);
  }

  trackRow(_index: number, row: FormGroup): FormGroup {
    return row;
  }

  onAddRow(): void {
    this.addRow.emit();
  }

  onRemoveRow(index: number): void {
    const row = this.controls[index];

    if (!row) {
      return;
    }

    if (!this.rowId(row)) {
      this.removeRow.emit(index);
      return;
    }

    this.confirmationDialogService.open(
      `Are you confident in your decision to remove this ${this.rowLabel}? It will be deleted when you save the meeting minute.`,
      () => this.removeRow.emit(index)
    );
  }
}
